<template>
  <div class="box"
       style="">
    <div class="box_title" style="">实时数据</div>
    <div class="year">{{ year }}</div>
    <div>-</div>
    <div class="time">{{ month }}</div>
    <div>-</div>
    <div class="time">{{ date }}</div>
    <div>&nbsp;&nbsp;</div>
    <div class="time">{{ hour }}</div>
    <div :style="{opacity:Number(show)}">:</div>
    <div class="time">{{ min }}</div>
    <div :style="{opacity:Number(show)}">:</div>
    <div class="time">{{ sec }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: '2022',
      month: '07',
      date: '06',
      hour: '00',
      min: '00',
      sec: '00',
      show: true,
      time1: null,
      time2: null

    }
  },
  methods: {
    getTime(t) {
      const now = new Date(t)
      this.year = now.getFullYear()
      const month = now.getMonth() + 1
      this.month = month > 9 ? month : '0' + month
      const date = now.getDate()
      this.date = date > 9 ? date : '0' + date
      const hour = now.getHours()
      this.hour = hour > 9 ? hour : '0' + hour
      const min = now.getMinutes()
      this.min = min > 9 ? min : '0' + min
      const sec = now.getSeconds()
      this.sec = sec > 9 ? sec : '0' + sec
    },
    getQueryString(name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i') // 正则语句
      let r = window.location.search.substr(1).match(reg) // 获取url的参数部分，用正则匹配
      if (r != null) {
        return decodeURIComponent(r[2]) // 解码得到的擦拭农户
      }
      return null
    }

  },
  mounted() {
    const today = new Date().getTime()
    const t = this.getQueryString('t') || today
    this.getTime(Number(t))

    this.time1 = setInterval(() => {
      let now = new Date().getTime()
      this.getTime(Number(t) + now - today)
    }, 1000)
    this.time2 = setInterval(() => {
      this.show = !this.show
    }, 500)
  },
  beforeDestroy() {
    clearInterval(this.time1)
    this.time1 = null
    clearInterval(this.time2)
    this.time2 = null
  }
}
</script>

<style scoped>
.box .box_title {
  margin-right: 15px;font-size: 60px;vertical-align: middle;width: 280px
}
.box {
  display: flex;
  align-items: baseline;
  position: absolute;
  right: 30px;
  bottom: 30px;
  font-size: 60px;
  justify-content: flex-end
}

.box > div {
  width: 40px;
  height: 80%;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.box > div.time {
  height: 100%;
  width: 60px;
}

.box > div.year {
  width: 120px;
  height: 100%;
}

@media screen and (max-width: 2000px) {
  .box {

    right: 15px;
    bottom: 62px;
    font-size: 25px;

  }
  .box > div {
    width: 17px;
    height: 80%;
    display: flex;
    align-items: baseline;
    justify-content: center;
  }

  .box > div.time {
    height: 100%;
    width: 30px;
  }

  .box > div.year {
    width: 60px;
    height: 100%;
  }
  .box .box_title {
    margin-right: 8px;font-size: 25px;vertical-align: middle;width: 150px
  }
}
</style>
